export const Loading4Icon = ({
  width = 40,
  height = 40,
  title = "Loading",
  ...rest
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    {...rest}>
    <title>{title}</title>
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M10.352 33.015v-11.36c0-3.125 1.347-7.424 3.268-8.431L15 12.5M29.598 9.058V29.49a2.046 2.046 0 0 1-2.05 2.041H19.97c.046-1.064-.104-2.519-.95-3.954a7.142 7.142 0 0 0-2.383-2.423v-3.982c0-.92-.556-1.71-1.35-2.055V9.058c0-1.128.917-2.041 2.05-2.041h10.21c1.133 0 2.051.913 2.051 2.04Z"
    />
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M19.766 33.015a7.62 7.62 0 0 0 .204-1.483c.046-1.064-.104-2.519-.95-3.954a7.143 7.143 0 0 0-2.383-2.423v-3.982c0-.92-.556-1.71-1.35-2.055a2.222 2.222 0 0 0-.905-.19.727.727 0 0 0-.73.725v7.38"
    />
    <path
      stroke="#5DCDFF"
      strokeMiterlimit={10}
      d="m23.47 11.052-2.999-.032s-.014.021-.024.032l-2.718 2.702a.474.474 0 0 1-.03.027v3.917l.03.026c.906.9 1.81 1.8 2.714 2.701.01.01.025.02.03.035h3.936c.006-.014.018-.022.029-.031.898-.895 1.797-1.79 2.698-2.684l.047-.045v-3.907l-2.779-2.771-.935.03Z"
    />
    <path
      fill="#00226A"
      d="M24.067 15.373a1.421 1.421 0 0 0-.143-.383h-.696v-.637c-.01-.014-.023-.016-.032-.02a1.526 1.526 0 0 0-.571-.12c-.36-.002-.716 0-1.075 0-.007 0-.016-.002-.025.007v1.482c0 .021.006.04.016.06l.66 1.287.11.217h.282c.118 0 .234-.013.348-.04a1.45 1.45 0 0 0 1.005-.78 1.59 1.59 0 0 0 .123-1.071l-.002-.002Zm-.756.835a.803.803 0 0 1-.563.373c-.104.02-.208.016-.312.016h-.239V14.88s.013-.004.018-.004c.15.002.297-.007.447.005.413.035.701.312.763.692a.903.903 0 0 1-.114.635ZM20.617 14.218c-.524 1.019-1.043 2.033-1.563 3.048h.723c.054-.103.107-.207.161-.308h1.358l.157.308h.723l-1.56-3.048h.001Zm-.355 2.103c.118-.228.234-.454.355-.685l.35.685h-.705Z"
    />
    <path
      fill="#00226A"
      d="M23.349 14.223v.651h.905v2.391h.67v-2.392h.91v-.65h-2.485Z"
    />
  </svg>
);
